import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class NacimientoService {
  constructor(private http: HttpClient) {}

  getSessionData(): Observable<any> {
    let sessionData = this.http.get<any[]>(
      environment.urlWebSitePhp + "api/GetSessionData"
    );
    return sessionData;
  }

  sendForm(enviarForm: FormData): Observable<any> {
    return this.http.post(
      `${environment.urlApi}nacimiento/sendBirthRequest?sid=` +
        environment.sessionId,
      enviarForm
    );
  }

  sendData(cuil: any, sessionId: any): Observable<any> {
    return this.http.get<any[]>(
      environment.urlApi +
        "aBeneficiarioData/getABeneficiarioData?sid=" +
        sessionId +
        "?cuil=" +
        cuil
    );
  }
}
